module.exports = __webpack_public_path__ + "static/img/huai4.91bffa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/huai4.jpg
// module id = ZoVn
// module chunks = 0